import { render, staticRenderFns } from "./AdminUserProfileOrders.vue?vue&type=template&id=74f22f0c&scoped=true"
import script from "./AdminUserProfileOrders.vue?vue&type=script&lang=js"
export * from "./AdminUserProfileOrders.vue?vue&type=script&lang=js"
import style0 from "./AdminUserProfileOrders.vue?vue&type=style&index=0&id=74f22f0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f22f0c",
  null
  
)

export default component.exports